import React from "react"
import styles from "./heading.module.scss"

const Heading = ({heading, colors, className=""}) => {
 return <h3 className={`${styles.element} ${className} bar-${colors}`}>{heading}</h3>
}

export default Heading